import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ToastrModule } from "ngx-toastr";
import { AgmCoreModule } from "@agm/core";
import { DeviceDetectorModule } from 'ngx-device-detector';
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { StoreModule } from "@ngrx/store";
import { DragulaService } from "ng2-dragula";
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';

import { AppRoutingModule } from "./app-routing.module";
import { SharedModule } from "./shared/shared.module";
import { AppComponent } from "./app.component";
import * as fromApp from './store/app.reducer';

import { AuthService } from "./shared/auth/auth.service";
import { AuthGuard } from "./shared/auth/auth-guard.service";
import { permissionReducer } from './permissions/store/permission.reducers';
import { dashboardInformationReducer } from './dashboardInformation/store/dashboard-information.reducers';
import { tokenInformationReducer } from './tokeninformation/store/token-information.reducers';
// import { screeninformationReducer } from './storeInformation/screenInformation/store/screeninformation.reducers';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
// import { DataTablesModule } from 'angular-datatables';
import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { WINDOW_PROVIDERS } from './shared/services/window.service';
import { loggedInUserInformationReducer } from './storeInformation/loogedInUserInformation/store/loggedinuser-information.reducers';
import { PersistenceModule } from 'angular-persistence';
import { configurationReducer } from "./configurations/store/configurations.reducers";
import { screenInformationReducer } from "./screeninformation/store/screeninformation.reducers";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { ColorPickerModule } from 'ngx-color-picker';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { storelocationReducer } from "./store/StorelocationInformation/store/StorelocationInformation.reducers";




var firebaseConfig = {
  apiKey: "YOUR_API_KEY", //YOUR_API_KEY
  authDomain: "YOUR_AUTH_DOMAIN", //YOUR_AUTH_DOMAIN
  databaseURL: "YOUR_DATABASE_URL", //YOUR_DATABASE_URL
  projectId: "YOUR_PROJECT_ID", //YOUR_PROJECT_ID
  storageBucket: "YOUR_STORAGE_BUCKET", //YOUR_STORAGE_BUCKET
  messagingSenderId: "YOUR_MESSAGING_SENDER_ID", //YOUR_MESSAGING_SENDER_ID
  appId: "YOUR_APP_ID", //YOUR_APP_ID
  measurementId: "YOUR_MEASUREMENT_ID" //YOUR_MEASUREMENT_ID
};


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent, FullLayoutComponent, ],
  imports: [
    BrowserAnimationsModule,
    StoreModule.forRoot(fromApp.appReducer),
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    ToastrModule.forRoot(),
    NgbModule,
    NgxSpinnerModule,
    DeviceDetectorModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    AgmCoreModule.forRoot({
      apiKey: "YOUR_GOOGLE_MAP_API_KEY"
    }),
    PerfectScrollbarModule,
    StoreModule.forFeature('permission', permissionReducer),
    StoreModule.forFeature('userInformation', dashboardInformationReducer),
    StoreModule.forFeature('tokenInformation', tokenInformationReducer),
    StoreModule.forFeature('loggedInUserInformation', loggedInUserInformationReducer),
    StoreModule.forFeature('configurations', configurationReducer),
    StoreModule.forFeature('screenInformation', screenInformationReducer),
    StoreModule.forFeature('storelocationInformation', storelocationReducer),
    StoreModule.forRoot({}),
    NgMultiSelectDropDownModule.forRoot(),
    PersistenceModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    ColorPickerModule,
    AngularDualListBoxModule
  ],
  providers: [
    AuthService,
    AuthGuard,
    DragulaService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
    WINDOW_PROVIDERS
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
